<div class="widget-container">
  <div class="progress-container" *ngFor="let d of data; trackById">
    <div class="progress">
      <div class="progress-bar" role="progressbar" style="width: 32%" [style.width]="d.value+'%'">{{ d.label }}</div>
    </div>
    <p>{{ d.value }}</p>
  </div>
</div>